import { render, staticRenderFns } from "./CPagination.vue?vue&type=template&id=3a8acc66&"
import script from "./CPagination.vue?vue&type=script&lang=js&"
export * from "./CPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports